// extracted by mini-css-extract-plugin
export var active = "_2k-9";
export var backButton = "_2k-8";
export var clone = "_2k-e";
export var collapseBar = "_2k-j";
export var collapseMode = "_2k-l";
export var collapsed = "_2k-n";
export var dragHandle = "_2k-c";
export var dropdownIcon = "_2k-g";
export var expanding = "_2k-m";
export var hidden = "_2k-w";
export var iconContainer = "_2k-p";
export var iconSwapper = "_2k-v";
export var navItem = "_2k-6";
export var navItemIcon = "_2k-f";
export var navProfile = "_2k-7";
export var notificationCountBadge = "_2k-i";
export var notificationDot = "_2k-q";
export var optionsContainer = "_2k-h";
export var primaryNav = "_2k-0";
export var primaryNavDivider = "_2k-u";
export var primaryNavResizeHandle = "_2k-2";
export var primaryNavResizing = "_2k-1";
export var primaryNavTabSection = "_2k-t";
export var primaryTab = "_2k-o";
export var primaryTabIconBox = "_2k-r";
export var secondaryNav = "_2k-3";
export var selected = "_2k-s";
export var settingsNav = "_2k-4";
export var settingsNavItems = "_2k-5";
export var show = "_2k-d";
export var sideNav = "_2k-k";
export var teamItem = "_2k-a";
export var userProfileItem = "_2k-b";